import React, { useState } from "react";
import Navbar from "../Component/navbar.jsx";
import Footer from "../Component/footer.jsx";
import { Link } from "react-router-dom";
import dote1 from "../image/icons/Ellipse 163.svg";
import dote2 from "../image/icons/Ellipse 164.svg";
import dote3 from "../image/icons/Ellipse 165.svg";
import rarrow from "../image/icons/rarrow.svg";
import bagor from "../image/icons/bagor.svg";
import dowarrow from "../image/icons/dowarrow.svg";
import ts1 from "../image/icons/ts1.svg";
import ts2 from "../image/icons/ts2.svg";
import ts3 from "../image/icons/ts3.svg";
import dotes from "../image/icons/dotes.svg";

const AboutUs = () => {
  const [linker] = useState("");

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Navbar />
      <div>
        <div>
          <div class=" mx-10">
            {/* <div className="px-10 py-10 text-4xl font-extrabold">About ResumeBeen</div> */}
            <div className="max-md:max-px-10 max-md:max-mx-20 max-md:max-w-full sm:px-10 sm:mx-20">
              <section>
                <div className="flex gap-0 mt-16 mb-48 max-md:flex-col max-md:gap-5 sm:gap-5 sm:">
                  <div className="flex flex-col  max-w-[884px] max-md:mt-10 max-md:max-w-full sm:w-full sm:pl:10">
                    <header className="flex flex-col self-center px-5 my-auto text-black max-md:mt-10 max-md:max-w-full">
                      <h1 className=" text-4xl font-bold text-left leading-[70px]  text-neutral-800 max-md:max-w-64 max-md:text-3xl max-md:leading-[35px] ">
                        ResumeBeen: Trusted advisor, advocate, and creator of
                        personalized, standout resumes for you.
                      </h1>
                      <p className="mt-3 text-base leading-7 tracking-normal text-left text-black max-md:max-w-64 max-md:text-center">
                        Let AI build your resume and choose from our curated
                        templates. Start now! Choose from our handpicked
                        selection of templates to give your resume a
                        professional edge. Success is just two steps away!
                      </p>
                      <div className="z-10 flex flex-col w-full pl-5 mt-0 ml-2 text-base leading-6 text-black max-md:pl-1 max-md:mt-0 max-md:max-w-full sm:pl-5">
                        <Link to={linker}>
                          <section className="flex self-start w-64 gap-3 px-3 py-2 my-12 text-white transition-colors duration-1000 border border-black bg-slate-700 rounded-xl hover:bg-white max-md:px-5 ">
                            <p className="my-auto text-xl hover:text-[#1D6362]">
                              Create my resume
                            </p>
                            <img
                              loading="lazy"
                              src="https://cdn.builder.io/api/v1/image/assets/TEMP/a74201ba4b9995e3135082ffa342eda686314d8dcf9e25310a286f8b8f4622f7?apiKey=e64c88474a2c4290b8b66f50b4a39c22&"
                              alt=""
                              className="w-8 shrink-0 aspect-square"
                            />
                          </section>
                        </Link>
                      </div>
                    </header>
                  </div>
                  <div className=" relative  w-[50%]  max-md:ml-0 max-md:w-full hidden sm:block">
                    <div className=" absolute w-96 mt-10 z-30 bg-white shadow-2xl aspect-[0.86] rounded-[30px] ">
                      <div className="flex gap-1 m-4 felx-col">
                        <img src={dote1} alt="" loading="lazy" />
                        <img src={dote2} alt="" loading="lazy" />
                        <img src={dote3} alt="" loading="lazy" />
                      </div>
                      <hr />
                      <div className="m-4 font-semibold">Build my resume</div>
                      <div className="flex gap-1 m-4 felx-col">
                        <div className="flex flex-col items-center justify-center w-24 gap-2 p-3 text-xs text-white transition-colors duration-1000 bg-orange-500 border border-gray-500 rounded-md h-28 hover:bg-orange-200">
                          {" "}
                          <img src={rarrow} alt="" /> Start
                        </div>
                        <div className="flex flex-col items-center justify-center w-24 gap-2 p-3 text-xs text-white transition-colors duration-1000 bg-orange-500 border border-gray-500 rounded-md h-28 hover:bg-orange-200">
                          <img src={bagor} alt="" /> Build
                        </div>
                        <div className="flex flex-col items-center justify-center w-24 gap-2 p-3 text-xs text-white transition-colors duration-1000 bg-orange-500 border border-gray-500 rounded-md h-28 hover:bg-orange-200">
                          <img src={dowarrow} alt="" /> Downlod
                        </div>
                      </div>
                      <div className="m-4 font-semibold text-gray-500">
                        Select Templates
                      </div>
                      <div className="flex gap-3 m-4 felx-col">
                        <div className="flex flex-col items-center justify-center gap-2 transition-colors duration-1000 border rounded-md hover:bg-gray-300">
                          {" "}
                          <img src={ts1} alt="" />
                        </div>
                        <div className="flex flex-col items-center justify-center gap-2 transition-colors duration-1000 border rounded-md hover:bg-gray-300">
                          <img src={ts2} alt="" />
                        </div>
                        <div className="flex flex-col items-center justify-center gap-2 transition-colors duration-1000 border rounded-md hover:bg-gray-300">
                          <img src={ts3} alt="" />
                        </div>
                      </div>
                    </div>
                    <div className=" absolute  z-0 grow w-96 mt-20 ml-10 bg-gray-900 shadow-2xl aspect-[0.86]  rounded-[30px] "></div>
                    <div className="absolute z-10 ml-40 grow w-96">
                      {" "}
                      <img src={dotes} alt="" />
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AboutUs;
